import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=77c879b4&scoped=true&"
import script from "./accountForm.vue?vue&type=script&lang=ts&"
export * from "./accountForm.vue?vue&type=script&lang=ts&"
import style0 from "./accountForm.vue?vue&type=style&index=0&id=77c879b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c879b4",
  null
  
)

export default component.exports